import { ContainerModule } from '@evertel/di'
import { DepartmentStore } from './store'
import { DepartmentController, DepartmentInvitesSearchController, DepartmentUserController, DepartmentsSearchController, ChildDepartmentController } from './controllers'

const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(DepartmentStore).toSelf().inSingletonScope()
        m.bind(DepartmentController).toSelf()
        m.bind(DepartmentInvitesSearchController).toSelf()
        m.bind(DepartmentUserController).toSelf()
        m.bind(DepartmentsSearchController).toSelf()
        m.bind(ChildDepartmentController).toSelf()
    })
]

export { DI_MODULES }
